import { AppPlanCode, getPlanName, planCodeToPlanPrivacy, planCodeToPlanType } from "common/app-plans";
import { IconImage } from "common/components/SerializedApp";
import { styled } from "sharedUI/styles";
import AppPlanIcon from "./private/app-plan-icon";
import { GlideFC } from "lib/glide-fc";
import { defined } from "@glideapps/ts-necessities";
import { ButtonVNext } from "designer/ui/smart/button-vnext/button-vnext";

const UpgradeSuccessContainer = styled.div`
    width: 336px;
    color: ${p => p.theme.textBase};
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 20px;

    > .title {
        font-size: 17px;
        font-weight: 700;
        margin: 8px 0px;
    }

    > .copy {
        text-align: center;
        &.separator {
            border-bottom: 1px solid ${p => p.theme.upgradeModal.border};
        }
        &.pad-bottom {
            padding-bottom: 16px;
        }
        &.pad-top {
            padding-top: 16px;
        }
        &.sm {
            width: 229px;
        }
    }

    > .privacy-settings {
        margin-top: 12px;
    }
`;

interface Props {
    appTitle: string;
    appPlanCode: AppPlanCode;
    appAccentColor: string;
    appIcon: IconImage;
    onNavigateToPrivacySettings: () => void;
}

const UpgradeSuccessModal: GlideFC<Props> = p => {
    const { appTitle, appPlanCode, appIcon, appAccentColor, onNavigateToPrivacySettings } = p;

    const planName = getPlanName(appPlanCode);
    const privacy = planCodeToPlanPrivacy(appPlanCode);
    const plan = planCodeToPlanType(appPlanCode);
    const msg = ` You've successfully upgrade ${appTitle} to the ${planName.short} Plan!`;

    const isProPrivate = appPlanCode === AppPlanCode.ProPrivateMonthly || appPlanCode === AppPlanCode.ProPrivateAnnual;

    const msgClass = isProPrivate ? "copy pad-bottom separator" : "copy pad-bottom";

    return (
        <UpgradeSuccessContainer>
            <AppPlanIcon
                size={64}
                appAccentColor={appAccentColor}
                appIcon={appIcon}
                shadow={true}
                plan={defined(plan, "this should alway be defined in upgrade flow")}
                privacy={privacy}
            />
            <div className="title">Congratulations!</div>
            <div className={msgClass}>{msg}</div>
            {isProPrivate && (
                <>
                    <div className="copy pad-top sm">
                        You can now go manage access to your app for you private users
                    </div>
                    <div className="privacy-settings">
                        <ButtonVNext
                            buttonType="minimal"
                            variant="accent"
                            size="lg"
                            label="Go to Private Sign In Settings"
                            onClick={onNavigateToPrivacySettings}
                        />
                    </div>
                </>
            )}
        </UpgradeSuccessContainer>
    );
};

export default UpgradeSuccessModal;
